import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=d473e1e6&scoped=true"
import script from "./edit.vue?vue&type=script&setup=true&lang=js"
export * from "./edit.vue?vue&type=script&setup=true&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=d473e1e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d473e1e6",
  null
  
)

export default component.exports